import { formatColor } from '@meitu/saas-colors';
import { checkLinearGradient } from '@/utils/color-kit';
import { getLayerCenterPoint } from '@/utils/layer-kit';
import {
    BrushDasharrayType,
    BrushLinecapType,
    BrushType,
    IBrushLayerProps,
    IBrushPoint,
    ILayerProps,
    ILinearGradient,
    IPoint,
} from '@/version-types';
import { getArrowBrushMinSize, getPathOffset } from './layer';

// 设置箭头笔大小
export function resetArrowSize(layer: ILayerProps, centerPoint: IPoint) {
    const data = layer.data as IBrushLayerProps;
    const { minHeight, minWidth } = getArrowBrushMinSize(data.fills[0].width, data.startPoint, data.endPoint);
    layer.height = minHeight;
    layer.width = Math.max(layer.width, minWidth);
    layer.left = ~~(centerPoint.x - layer.width / 2);
    layer.top = ~~(centerPoint.y - layer.height / 2);
}

// 设置颜色
export function setColor(layer: ILayerProps, color: string, isStroke = false, index = 0) {
    const isGradient = checkLinearGradient(color);
    const data = layer.data as IBrushLayerProps;
    const resColor = isGradient ? (formatColor(color) as ILinearGradient) : color;
    if (isStroke) {
        data.stroke.color = resColor;
    } else {
        data.fills[index].color = resColor;
    }
}
// 设置粗细
export function setWidth(layer: ILayerProps, width: number, centerPoint: IPoint, isStroke = false) {
    const data = layer.data as IBrushLayerProps;
    if (isStroke) {
        data.stroke.width = width;
    } else {
        data.fills.forEach((item, index) => {
            item.width = width;
            // 重新计算偏移量
            if (index) {
                item.offsetX = Math.ceil(((item.offsetX / Math.abs(item.offsetX)) * width) / 3);
                item.offsetY = Math.ceil(((item.offsetY / Math.abs(item.offsetY)) * width) / 3);
            }
        });
    }
    // 重新计算大小/位置
    if (data.brushType === BrushType.Arrow && !isStroke) {
        resetArrowSize(layer, centerPoint);
    }
    if (data.brushType === BrushType.Line) {
        const res = getPathOffset(data.fills, data.stroke);
        layer.width = data.naturalWidth + res.offsetWidth;
        layer.height = data.naturalHeight + res.offsetHeight;
        layer.left = ~~(centerPoint.x - layer.width / 2);
        layer.top = ~~(centerPoint.y - layer.height / 2);
    }
}
// 设置矩形圆角
export function setRadius(layer: ILayerProps, radius: number) {
    const data = layer.data as IBrushLayerProps;
    data.radius = radius;
}
// 设置样式
export function setStyle(
    layer: ILayerProps,
    dasharray: BrushDasharrayType,
    linecap: BrushLinecapType,
    isStroke = false,
) {
    const data = layer.data as IBrushLayerProps;
    if (isStroke) {
        data.stroke.dasharray = dasharray;
        data.stroke.linecap = linecap;
    } else {
        data.fills.forEach((item) => {
            item.dasharray = dasharray;
            item.linecap = linecap;
        });
    }
}

// 设置端点
export function setPoint(layer: ILayerProps, point: IBrushPoint, isStart: boolean) {
    const data = layer.data as IBrushLayerProps;
    if (isStart) {
        data.startPoint = point;
    } else {
        data.endPoint = point;
    }
    resetArrowSize(layer, getLayerCenterPoint(layer));
}

export function setSwap(layer: ILayerProps, startPoint: IBrushPoint, endPoint: IBrushPoint) {
    const data = layer.data as IBrushLayerProps;
    data.startPoint = startPoint;
    data.endPoint = endPoint;
    resetArrowSize(layer, getLayerCenterPoint(layer));
}

export enum AttrOperate {
    color = 'color',
    width = 'stroke',
    style = 'style',
    radius = 'radius',
    point = 'point',
    swap = 'swap',
}
